<div  [class.loader-wrapper]="show">
  <div [class.loader]="show"></div>
</div>
